import { Axios } from 'utils/AxiosConfig'

export const getBanner = async () => {
  const { data: response } = await Axios.get(`public/banner`)
  return response
}

export const getNotification = async () => {
  const res = await Axios.get(`member/notification`)
  return res
}

export const putNotificationStatus = async (id) => {
  const { data: response } = await Axios.put(`member/notification/read/${id}`)
  return response
}

export const postCalculateExtraBundle = async (payload) => {
  const { data: response } = await Axios.post(`member/paid-service/calculate`, payload)
  return response
}
export const getLandingCompanyForSale = async () => {
  const { data: response } = await Axios.get(`public/landing-page/seller`)
  return response
}
export const getLandingWantedCompany = async () => {
  const { data: response } = await Axios.get(`public/landing-page/buyer`)
  return response
}
export const getLandingAdvisor = async () => {
  const { data: response } = await Axios.get(`public/landing-page/advisor`)
  return response
}
